export const defaultTableOptions = {
  emptyRowsWhenPaging: false,
  actionsColumnIndex: -1,
  pageSize: 10,
  pageSizeOptions: [10, 15, 20, 50, 100],
  headerStyle: {
    backgroundColor: "#e8eef7",
    color: "#0b2e62",
    fontWeight: "bold",
    position: "sticky",
    top: 0,
    fontSize: 16,
    borderBottom: "2px solid #cbd5e1",
  },
  rowStyle: {
    fontSize: 16,
  },
};
